<template>
  <div>
    <label
      v-if="label || $slots.label"
      :for="id"
      :class="isLabelVisible ? 'mb-3 inline-block text-base text-blue-950 lg:text-xl' : 'sr-only'"
    >
      {{ label }}
      <slot v-if="!label" name="label" />
    </label>
    <div>
      <slot />
    </div>
    <div class="grid min-h-[24px] w-full grid-cols-2 items-center text-sm lg:min-h-[28px]">
      <Transition name="label">
        <div
          v-if="isError"
          class="mt-2 text-red"
          :class="slots.bottomEnd ? 'col-span-1' : 'col-span-2'"
        >
          {{ errorMessage ? errorMessage : $t('inquiryForm.requiredField') }}
        </div>
      </Transition>
      <div v-if="slots.bottomEnd" class="col-span-1 col-start-2 mt-2 text-right">
        <slot name="bottomEnd" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface InputProps {
  id?: string
  label?: string
  isLabelVisible?: boolean
  isDisabled?: boolean
  isError?: boolean
  errorMessage?: string
}

withDefaults(defineProps<InputProps>(), {
  isLabelVisible: true,
  isDisabled: false,
  isError: false
})

const slots = useSlots()
</script>
